import React, { useState, useEffect, useRef, useMemo } from "react";
import { Form, Spin } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import Button from "@/common/elements/Button";
import DataTable from "@/common/elements/DataTable";
import CustomModal from "@/components/CustomModal";
import { StyledFlex, StyledSubTableContainer } from "@/common/styles";
import GroupMembersForm from "@/pages/Security/Sections/StaffGroupForms/GroupMembersForm";
import {
  fetchStaffGroups,
  fetchStaffGroupById,
  createStaffGroup,
  updateStaffGroup,
  deleteStaffGroup,
} from "@/apis/security/staffGroupsApi";
import { clearCurrent } from "@/slices/staffGroupsSlice";
import { fetchAllSecurityListOfStaff } from "@/apis/staff/staffApi";
import GroupMembersForm2 from "@/pages/Staffing/GroupMembersForm2";
import { createStaffGroupMember, deleteStaffGroupMember, updateStaffGroupMember } from "@/apis/security/staffGroupMemberApi";
import { isNonEmptyVariable } from "@/util/common_function";
import { setBookings } from "@/slices/bookingsSlice";
import useDialog from "@/hooks/useDialog";
import dayjs from "dayjs";


const UserInfoStaffGroups = ({ bookingsFieldsEnabled = true }) => {
  // const staffId = 8;
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const dataTableRef = useRef();

  // const list = useSelector((s) => s.staffGroups.list) || [];
  const list = useSelector((s) => s.staff.securityList) || [];
  const { bookings } = useSelector((s) => s?.bookings);
  const staffId = bookings?.staffId
  const { showDialog } = useDialog();

  // const current = useSelector((s) => s.staffGroups.current);
  const loadingList = useSelector((s) => s.staffGroups.listLoading);
  // const loadingCurrent = useSelector((s) => s.staffGroups.currentLoading);
  // const loadingSave = useSelector((s) => s.staffGroups.saveLoading);
  // const loadingDelete = useSelector((s) => s.staffGroups.deleteLoading);

  const [selectedRow, setSelectedRow] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [mode, setMode] = useState("add"); // "add" or "edit"
  // load all staff-groups; will filter by staffId later
  const loadGroups = () => {
    // dispatch(fetchStaffGroups());
    if (staffId)
      dispatch(fetchAllSecurityListOfStaff(staffId))
  };

  useEffect(() => {
    if (staffId != null) loadGroups();
  }, [staffId, dispatch]);

  // list is all groups; for now show all—filter when dedicated API is ready
  const displayData = useMemo(() => list, [list]);
  
  const finalDisplayData = useMemo(() => {
    const staff = bookings?.staffGroupMembers || [];

    return staff.map((item) => {
      const id = item.staffGroupsID ?? item.staffGroupsId;

      // find matching entry from list for initial names
      const fromList = list.find((l) => l.staffGroupsID === id);

      return {
        // 🔥 include everything from list first
        ...(fromList || {}),

        // 🔥 include everything from item next (item overrides list)
        ...(item || {}),

        // 🔥 normalize the final fields used by UI
        staffGroupsID: id,
        groupName:
          item.groupName ||
          fromList?.groupName ||
          fromList?.staffGroupsLabel,

        dateAdded: item.dateAdded ?? fromList?.dateAdded,
      };
    });
  }, [bookings, list]);


  const onRowClick = (row, index) => {
    setSelectedRow(row);
    if(index !== null && index !== undefined) {
      openEdit();
    }
  };

  const openAdd = () => {
    setIsLoading(true)
    form.resetFields();
    dispatch(clearCurrent());
    setMode("add");
    setSelectedRow(null);
    setModalOpen(true);
  };

  const openEdit = () => {
    setIsLoading(true)
    if (!selectedRow) return;
    setMode("edit");
    dispatch(fetchStaffGroupById(selectedRow.staffGroupsID));
    setModalOpen(true);
  };

  const openDelete = () => {
    if (!selectedRow) return;
    setIsLoading(true)
    showDialog("confirm", {
      title: "Are you sure you want to delete this record?",
      onConfirm: () => confirmDelete(),
      onCancel: () => { setIsLoading(false) }
    });

  };
  const confirmDelete = () => {
    console.log("delete")
    if (!selectedRow || !isNonEmptyVariable(staffId)) {
      console.log("1st if")
      setIsLoading(false);
      return
    };
    console.log(selectedRow)
    let staffGroupMembers = selectedRow?.staffGroupMembers;
    let staffGroupMemberId = null

    if (isNonEmptyVariable(staffGroupMembers)) {
      let staffGroupMember = staffGroupMembers?.find((e, i) => e?.memberStaffId == staffId)
      console.log({ staffGroupMember })
      if (isNonEmptyVariable(staffGroupMember)) {
        staffGroupMemberId = staffGroupMember.staffGroupMembersID
      }
    }
    if (!isNonEmptyVariable(staffGroupMemberId)) {
      setIsLoading(false)
      return
    }
    let staffGroupMembersCopy = bookings?.staffGroupMembers
    if (isNonEmptyVariable(staffGroupMembersCopy)) {
      staffGroupMembersCopy = staffGroupMembersCopy.filter((e, i) => e?.staffGroupMembersID != staffGroupMemberId)
      dispatch(setBookings({
        ...bookings,
        staffGroupMembers: [...staffGroupMembersCopy]
      }))
    }
    dispatch(deleteStaffGroupMember(staffGroupMemberId)).then(() => { loadGroups(); setIsLoading(false) });
    setSelectedRow(null);
  }
  const closeModal = () => {
    setModalOpen(false); setIsLoading(false)
  };
  const handleSave = () => form.submit();
  const handleCancel = () => {
    setSelectedRow(null)
    dataTableRef.current.resetAll()
  }
  const onFinish = (values) => {
    console.log("Form Values : ", values);
    const payload = {
      ...values,
      staffGroupsId: values?.staffGroupsId?.value,   // selected value
      groupName: values?.staffGroupsId?.label, // selected label
      dateAdded: values.dateAdded
        ? values.dateAdded.format("MM/DD/YYYY")
        : dayjs().format("MM/DD/YYYY"),
      timeAdded: values.timeAdded
        ? values.timeAdded.format("HH:mm")
        : dayjs().format("HH:mm"),
      memberStaffId: staffId,
    };

    console.log("List : ",list);
    console.log("Form payload : ", payload);
    if (mode === "add") {
      dispatch(
        setBookings({
          ...bookings,
          staffGroupMembers: [
            ...(bookings?.staffGroupMembers || []),
            payload
          ]
        })
      );
    } else {
      console.log("else la poguthu");
      console.log(bookings?.staffGroupMembers)
      console.log(selectedRow)
      console.log(payload)
      const updatedList = (bookings?.staffGroupMembers || []).map((item) =>
        (item.staffGroupsId === (selectedRow.staffGroupsID ?? selectedRow.staffGroupsId) && payload.staffGroupsId)
          ? payload                  // ← replace entire item
          : item
      );
      console.log(updatedList)
      dispatch(
        setBookings({
          ...bookings,
          staffGroupMembers: updatedList
        })
      );
      loadGroups();
      setIsLoading(false);
    }

    const mergedGroups = (() => {
      const normalize = (g) => ({
        staffGroupsID: g.staffGroupsId ?? g.staffGroupsID,
        groupName: g.groupName ?? g.staffGroupsLabel,
        dateAdded: g.dateAdded,
      });

      const map = new Map();

      // 1️⃣ Add list items
      list.forEach(g => {
        map.set(g.staffGroupsID, normalize(g));
      });

      // 2️⃣ Add staffGroupMembers (override list)
      (bookings?.staffGroupMembers || []).forEach(bg => {
        map.set(bg.staffGroupsId, normalize(bg));
      });

      // 3️⃣ If EDIT mode — remove the OLD ID
      if (mode !== "add") {
        const oldId = selectedRow.staffGroupsID ?? selectedRow.staffGroupsId;
        map.delete(oldId);
      }

      // 4️⃣ Insert the NEW updated payload (will override any existing)
      map.set(payload.staffGroupsId, normalize(payload));

      return Array.from(map.values());
    })();
    // setDisplayData(mergedGroups);
    closeModal();
  };

  const headers = [
    { key: "groupName", text: "Group Name" },
    { key: "dateAdded", text: "Date Added" },
    { key: "staffGroupsID", text: "Group ID" },
  ];

  return (
    <>
      <StyledSubTableContainer>
        <StyledFlex justify="space-between" align="center">
          <h2>Groups Assigned to Staff</h2>
          <StyledFlex gap="10px" marginBottom="5px" justify="end">
            <Button onClick={openAdd} disabled={!bookingsFieldsEnabled}>
              <PlusOutlined /> Add
            </Button>
            <Button onClick={openEdit} disabled={!selectedRow} >
              Details
            </Button>
            <Button onClick={openDelete} disabled={!selectedRow || !bookingsFieldsEnabled}>
              Delete
            </Button>
            <Button onClick={handleCancel} disabled={!selectedRow} >
              Cancel
            </Button>
          </StyledFlex>
        </StyledFlex>

        <Spin spinning={loadingList}>
          <DataTable
            headers={headers}
            data={finalDisplayData}
            ref={dataTableRef}
            rowUniqueId="staffGroupsID"
            onRowClick={onRowClick}
            allowTableSorting
            autoResetSelection={false}
            selected={selectedRow === null}
            isAPiCallLoading={isLoading}
          />
        </Spin>
      </StyledSubTableContainer>

      {isModalOpen && (
        <CustomModal
          size="lg"
          header={mode === "add" ? "Add Staff Group" : "Modify Staff Group"}
          show={isModalOpen}
          onHide={closeModal}
          onSaveClick={handleSave}
          backdrop={false}
          // confirmLoading={loadingSave}
          isDisabled={!bookingsFieldsEnabled}
        >
          <GroupMembersForm2
            form={form}
            initialValues={mode === "edit" ? selectedRow : {}}
            onFinish={onFinish}
            disabled={!bookingsFieldsEnabled}
          />
        </CustomModal>
      )}
    </>
  );
};

export default UserInfoStaffGroups;
